// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Fbz","textarea":"styles_textarea__ZWm9B"};